import React, { Component } from "react";
import "./styles.css";
import SummaryItem from "./summary-item";
import SidebarItem from "./sidebar-item";

class SummarySection extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.createSummaryItem = this.createSummaryItem.bind(this);
  }



  // ===============================================================================================
  // Create and return summary item
  createSummaryItem(item, defaultLabel, summaryInfo) {
    let newSummaryItem = {
      type: item.id,
      error: null,
      visited: false,
      summary: { label: item.title },
      // summary: { label: defaultLabel },
    };

    if (this.props.visitedSlides && this.props.visitedSlides.length) {
      newSummaryItem.visited = (this.props.visitedSlides.indexOf(item.key) === -1) ? false : true;
    }

    if (newSummaryItem.visited) {
      if (summaryInfo.summary) {
        newSummaryItem.summary = summaryInfo.summary;
      }

      if (summaryInfo.error && this.props.activeSlide !== item.key) {
        newSummaryItem.error   = summaryInfo.error;
      }
    }

    return newSummaryItem;
  }



  // ===============================================================================================
  render() {
    // ---------------------------------------------------------------------------------------------
    // Loop through sections and create summaries
    let items = this.props.items;
    let summaries = [];

    for (let i = 0; i < items.length; i++) {
      let summaryObj = null;

      // Create a unique object for each summary type
      switch(items[i].id) {

        case "package": {
          summaryObj = this.createSummaryItem(
            items[i],
            "Review the package section",
            this.props.sPackage
          );
        break; }

        case "location": {
          summaryObj = this.createSummaryItem(
            items[i],
            "Review the location section",
            this.props.sLocation
          );
        break; }

        case "datetime": {
          summaryObj = this.createSummaryItem(
            items[i],
            "Review the date & time section",
            this.props.sDatetime
          );
        break; }

        case "cake": {
          summaryObj = this.createSummaryItem(
            items[i],
            "Review the cake section",
            this.props.sCake
          );
        break; }

        case "summary": {
          summaryObj = this.createSummaryItem(
            items[i],
            "Review the summary section",
            this.props.sSummary
          );
        break; }

        default: {
          // Empty
        }

      }

      // Add summary if it exists
      if (summaryObj) {
        summaryObj.key = i;
        summaries.push(summaryObj);
      }
    }



    // ---------------------------------------------------------------------------------------------
    // Choose which type of button to use
    let viewSummaryButtons = null;

    switch (this.props.type) {
      case "summary":

        viewSummaryButtons = summaries.map((item) => (
          <SummaryItem
            key={item.type}
            type={item.type}
            summary={item.summary}
            error={item.error}
            visited={item.visited}
            current={item.key}
            active={this.props.activeSlide}
            handleClick={this.props.handleClick}
          />
        ));
        break;

      case "sidebar":
        viewSummaryButtons = summaries.map((item) => (
          <SidebarItem
            key={item.type}
            type={item.type}
            summary={item.summary}
            error={item.error}
            visited={item.visited}
            current={item.key}
            active={this.props.activeSlide}
            handleClick={this.props.handleClick}
          />
        ));
        break;

      default: // Empty
    }



    // ---------------------------------------------------------------------------------------------
    return (
      <div className="summary-section">
        {viewSummaryButtons}
      </div>
    );
  }

}



export default SummarySection
